import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { forkJoin } from 'rxjs';
import { SiteFile } from 'src/app/classes/models';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { SiteService } from 'src/app/services/site.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-site-files-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    '../base-grid/base-grid.component.less',
    './site-files-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteFilesGridComponent
  extends BaseGridComponent
  implements OnInit
{
  constructor(
    private SiteService: SiteService,
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService
  ) {
    super(GridService, UtilityService, AuthService);
  }

  override ngOnInit(): void {
    this.gridPrimaryKeyFieldName = 'FileId';
    this.gridType = 'SiteFile';
    this.rowModelType = 'serverSide';

    // Override default. This table does not have an id.
    this.additionalQueryData = { attributes: ['SiteId', 'FileId'] };

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.SiteService.getSiteFiles(queryObject),
          this.SiteService.getSiteFileCount(countQueryObject)
        ]).subscribe({
          next: ([SiteFiles, siteFileCount]) => {
            const successObject: { rowData: SiteFile[]; rowCount: number } = {
              rowData: SiteFiles,
              rowCount: siteFileCount
            };

            params.success(successObject);
          },
          error: (err) => {
            console.log(err);
            params.fail();
          }
        });
      }
    };
  }
}
